import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles(() => ({
  progress: {
    width: "12px !important",
    height: "12px !important",
  },
}));

export default useStyle;
